import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadDashboard,
  loadHealthDashboard,
  loadOccupancyDashboard,
} from "../../actions/dashboardAction";
import { getScanInfo, clearScanInfo } from "../../actions/3dFusionAction";

import DashboardForm from "./components/DashboardForm";
import DashboardHealth from "./components/DashboardHealth";
import { Link, useNavigate } from "react-router-dom";
import DashboardOccupancy from "./components/DashboardOccupancy";
import { motion } from "framer-motion";
import { floatIn } from "../../utils/motion";
import LiteDashboard from "../lite/LiteDashboard";
import LiteReport from "../lite/LiteReport";
import { setBuilding, setFloor } from "../../actions/dataActions";

const Dashboard = ({ domain, activeTab, tabContent }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dark = useSelector((state) => state.dark.data);
  const healthDashboard = useSelector((state) => state.healthDashboard.data);
  const performanceDashboard = useSelector(
    (state) => state.performanceDashboard.data
  );
  const dashboard = useSelector((state) => state.dashboard.data);
  const dashboardloading = useSelector((state) => state.dashboard.loading);
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const authLoading = useSelector((state) => state.auth.loading);
  const building = useSelector((state) => state.building.data);
  const floor = useSelector((state) => state.floor.data);


  // Determine what to render based on user and domain
  const renderDashboard = () => {
    if (
      user &&
    (user.client_id === 32 || user.client_id === 37)  &&
      (domain === "virbrixlite") && tabContent && tabContent !=="" && tabContent !== 'report-wizard'
    ) {
      return (
        <>
          <LiteDashboard
            activeTab={activeTab}
            tabContent={tabContent}
          />
        </>
      );
    }

    if(user && user.client_id === 32 && domain === "virbrixlite" && tabContent && tabContent === 'report-wizard'){
      return <LiteReport />;
    }

    // Handle client 1 on virbrixlite
    if (user && user.client_id === 1 && (domain === "virbrixlite") && tabContent && tabContent !== "") {
      return (
        <>
          <LiteDashboard
            activeTab={activeTab}
            tabContent={tabContent}
          />
        </>
      );
    }

    // Return null for these specific cases
    if (
      (user && (user.client_id === 32 || user.client_id === 37) && domain === "virbrix") 
    ) {
      return <div className="text-white fs-5 text-center">
    You don’t have permission to access this page. Please check your account settings or contact your administrator for assistance.
      </div>;
    }


    //Main Dashboard 
    if( !authLoading && !dashboardloading && isAuthenticated && domain === "virbrix" ){
  return (
      <div className="row w-100 h-100 flex-column flex-lg-row p-3">
        <div className="col-12 col-lg-4 order-2 order-lg-1">
          <div className="d-flex flex-column h-100 justify-content-between gap-3">
            <DashboardHealth dataList={healthDashboard} />
            {user && user.role_id === 1 && floor ? (
              <Link to="/sustainability">
                <motion.img
                  width="100%"
                  src={`/images/Safety Box${dark ? "" : " Light"}.png`}
                  alt=""
                  className="my-5"
                  variants={floatIn}
                  initial="hidden"
                  whileInView="show"
                  whileHover={{ scale: 0.95 }}
                />
              </Link>
            ) : (
              <motion.img
                width="100%"
                src={`/images/Safety Box${dark ? "" : " Light"}.png`}
                alt=""
                className="my-5"
                variants={floatIn}
                initial="hidden"
                whileInView="show"
              />
            )}
          </div>
        </div>
        <div className="col-12 col-lg-4 h-100 order-1 order-lg-2">
          {dashboard !== undefined && user.client_id !== 36 && (
            <DashboardForm data={dashboard} user={user} />
          )}
        </div>
        <div className="col-12 col-lg-4 order-3">
          <div className="d-flex flex-column h-100 justify-content-between gap-3">
            <DashboardOccupancy dataList={performanceDashboard} />
            {user && user.role_id === 1 && floor ? (
              <Link to="/security">
                <motion.img
                  width="100%"
                  src={`./images/Security Box${dark ? "" : " Light"}.png`}
                  alt=""
                  className="my-5"
                  variants={floatIn}
                  initial="hidden"
                  whileInView="show"
                  whileHover={{ scale: 0.95 }}
                />
              </Link>
            ) : (
              <motion.img
                width="100%"
                src={`./images/Security Box${dark ? "" : " Light"}.png`}
                alt=""
                className="my-5"
                variants={floatIn}
                initial="hidden"
                whileInView="show"
              />
            )}
          </div>
        </div>
      </div>
    );
    }

    return null; 
  };


  // Dashboard
  useEffect(() => {
    if (!dashboard && !dashboardloading && isAuthenticated && domain === "virbrix") {
      dispatch(loadDashboard());
    }

    if (!isAuthenticated && !authLoading && domain === "virbrix") navigate("/");

    if(domain === 'virbrix' && user && user.role_id ===5 && dashboard){
      console.log("test dashboard load", dashboard)
      dispatch(setBuilding(dashboard[0]));
      dispatch(setFloor(dashboard[0].floors[0]));
      dispatch(getScanInfo(dashboard[0].floors[0].id));
      navigate("/3dfusion");
    }
  }, [loadDashboard, dashboard, dashboardloading, isAuthenticated, domain]);

  // load Health dashboard
  useEffect(() => {
    if (!healthDashboard && isAuthenticated && !building && dashboard && domain === "virbrix") {
      dispatch(loadHealthDashboard());
    }
  }, [loadHealthDashboard, healthDashboard, dashboard, isAuthenticated, domain]);

  // load Occupancy dashboard
  useEffect(() => {
    if (!performanceDashboard && isAuthenticated && !building && dashboard && domain === "virbrix") {
      dispatch(loadOccupancyDashboard());
    }
  }, [
    loadOccupancyDashboard,
    performanceDashboard,
    dashboard,
    isAuthenticated,
    domain,
  ]);

  // Change Building
  useEffect(() => {
    if (building && !floor && domain === "virbrix") {
      dispatch(loadHealthDashboard(building.id));
      dispatch(loadOccupancyDashboard(building.id));
      dispatch(clearScanInfo());
    }
  }, [loadHealthDashboard, loadOccupancyDashboard, building, ]);

  // Change floor
  useEffect(() => {
    if (floor && building && domain === "virbrix") {
      dispatch(loadHealthDashboard(building.id, floor.id));
      dispatch(loadOccupancyDashboard(building.id, floor.id));
      dispatch(getScanInfo(floor.id));
    }

  }, [loadHealthDashboard, loadOccupancyDashboard, floor, domain, dashboard]);


  return (
   isAuthenticated && <div
      className="dashboard h-100 w-100 overflow-y-auto overflow-x-hidden"
      style={{
        backgroundImage: `url('./images/building${dark ? "" : "-Light"}.png')`,
      }}
    >
        <div className="d-flex align-items-center justify-content-center h-100 ">
          {renderDashboard()}
        </div>
    </div>
  );
};

export default Dashboard;
